import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { LoadingButton } from '@mui/lab';
import { Box, Card, Grid, Paper, Stack, TextField, Typography, useTheme, Avatar } from '@mui/material';
import * as React from 'react';
import { useState } from 'react';
import { ClientInfoType } from '../../all-types';
import { useAppDispatch, useAppSelector } from '../../redux-store/hooks';
import { BottomSaveBar } from './components';
import { updateClientInfo } from '../../services';

const ClientInfo: React.FC = () => {
    const theme = useTheme();
    const info = useAppSelector(state => state.clientInfo.data);
    const [clientInfo, setClientInfo] = useState<ClientInfoType>(info);
    const dispatcher = useAppDispatch();
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = event.target;
        setClientInfo((prev) => ({ ...prev, [name]: value }));
    };

    const handleAddressChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, field: string) => {
        setClientInfo((prev) => ({
            ...prev,
            address: { ...prev.address, [field]: event.target.value },
        }));
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        console.log(clientInfo);
    };

    const addressFields: (keyof ClientInfoType['address'])[] = [
        'shopNo',
        'buildingName',
        'area',
        'city',
        'state',
        'landmark',
        'fullAddress',
        'pincode'
    ];


    const updateClientdata = async () => {
        try {
            const tempClient = { ...clientInfo };
            await dispatcher(updateClientInfo({
                clientId: tempClient._id || "",
                body: tempClient
            }));
        } catch (e) {
            console.error(e);
        }
    }

    return (
        <Box sx={{ maxWidth: 1000, mx: 'auto', p: 3 }}>

            <form onSubmit={handleSubmit}>
                <Card sx={{ p: 3, borderRadius: 4, boxShadow: 3 }}>
                    <Grid container spacing={3}>

                        {/* Logo Upload */}
                        <Grid item xs={12} sm={4}>
                            <Stack alignItems="center" spacing={2}>
                                <Avatar
                                    src={clientInfo?.clientLogo || ''}
                                    alt="Client Logo"
                                    sx={{ width: 150, height: 150, borderRadius: '50%', boxShadow: 2 }}
                                />
                                <LoadingButton
                                    component="label"
                                    color='primary'
                                    variant='contained'
                                    loadingIndicator="Uploading…"
                                    startIcon={<CloudUploadIcon />}
                                    sx={{ borderRadius: 2 }}
                                >
                                    {clientInfo?.clientLogo ? "Change Image" : "Upload Image"}
                                    <input
                                        type="file"
                                        hidden
                                        accept="image/*"
                                    />
                                </LoadingButton>
                            </Stack>
                        </Grid>

                        {/* Basic Info */}
                        <Grid item xs={12} sm={8}>
                            <Stack spacing={2}>
                                <TextField
                                    name="clientName"
                                    label="Client Name"
                                    value={clientInfo.clientName}
                                    onChange={handleInputChange}
                                    fullWidth
                                />
                                <TextField
                                    name="PhoneNumber"
                                    label="Phone Number"
                                    value={clientInfo.PhoneNumber}
                                    onChange={handleInputChange}
                                    fullWidth
                                />
                                <TextField
                                    name="email"
                                    label="Email"
                                    value={clientInfo.email}
                                    onChange={handleInputChange}
                                    fullWidth
                                />
                                 <TextField
                                    name="website"
                                    label="Website"
                                    value={clientInfo.website}
                                    onChange={handleInputChange}
                                    fullWidth
                                />
                            </Stack>
                        </Grid>

                        {/* Shop Info */}
                        <Grid item xs={12}>
                            <Typography variant="h6" fontWeight="bold" gutterBottom>
                                Shop Information
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="gstNo"
                                label="GST No"
                                value={clientInfo.gstNo}
                                onChange={handleInputChange}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="fssaiNo"
                                label="FSSAI No"
                                value={clientInfo.fssaiNo}
                                onChange={handleInputChange}
                                fullWidth
                            />
                        </Grid>

                        {/* Address */}
                        <Grid item xs={12}>
                            <Typography variant="h6" fontWeight="bold" gutterBottom>
                                Address
                            </Typography>
                        </Grid>

                        {addressFields.map((field, i) => (
                            <Grid key={field} item xs={12} sm={6}>
                                <TextField
                                    name={field}
                                    label={field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                                    value={clientInfo.address[field]?.toString() || ''}
                                    onChange={(e) => handleAddressChange(e, field)}
                                    fullWidth
                                />
                            </Grid>
                        ))}

                    </Grid>
                </Card>

                <BottomSaveBar onSave={updateClientdata} />
            </form>
        </Box>
    );
};

export { ClientInfo };
